import { AttachingFile } from './IGraduateFilterObjMsg';

export class IGraduateAttach{
    attachingFiles:Array<AttachingFile>=[];
}